/**
 * @param obj
 * @returns 
 */
export const filterNullAndEmptyStrings = (obj: any): any => {
  if (obj === null || obj === undefined) {
    return obj;
  }

  if (typeof obj === 'string') {
    // Handle at the parent level
    return obj;
  }

  if (Array.isArray(obj)) {
    // Process each element in the array
    return obj.map(item => filterNullAndEmptyStrings(item)).filter(item => {
      // Filter out null, undefined, and empty strings from the array
      return item !== null && item !== undefined && !(typeof item === 'string' && item.trim() === '');
    });
  }

  if (typeof obj === 'object') {
    const filteredObj: any = {};

    for (const [key, value] of Object.entries(obj)) {
      const filteredValue = filterNullAndEmptyStrings(value);

      // Only include the property if it's not null, undefined, or an empty string
      if (filteredValue !== null && filteredValue !== undefined) {
        // If it's a string and it's empty after trimming, exclude it
        if (typeof filteredValue === 'string' && filteredValue.trim() === '') {
          continue;
        }
        // If the filtered value is an object/array that ends up being empty after filtering, exclude it
        if (typeof filteredValue === 'object' &&
            !Array.isArray(filteredValue) &&
            Object.keys(filteredValue).length === 0) {
          continue;
        }
        // If it's an array that ends up being empty after filtering, exclude it
        if (Array.isArray(filteredValue) && filteredValue.length === 0) {
          continue;
        }

        filteredObj[key] = filteredValue;
      }
    }

    return filteredObj;
  }

  return obj;
};